<template>
  <transition
    :name="transition"
    :duration="duration"
    mode="out-in"
    v-if="!withoutLoading"
  >
    <div :key="currentState">
      <slot v-if="currentState === 'ok'" />
      <slot
        name="loading"
        v-else-if="
          currentState === 'loading' ||
            (withoutError && currentState === 'error')
        "
      />
      <slot name="error" v-else-if="currentState === 'error'" />
    </div>
  </transition>
  <div v-else>
    <slot v-if="['ok', 'loading'].includes(currentState)" />
    <slot name="error" v-else-if="currentState === 'error'" />
  </div>
</template>

<script>
export default {
  name: "loader",

  props: {
    state: [String, Array],
    duration: {
      type: Number,
      default: 100
    },

    transition: {
      type: String,
      default: "fade"
    },

    withoutLoading: Boolean,
    withoutError: Boolean
  },

  computed: {
    stateArray() {
      return Array.isArray(this.state) ? this.state : [this.state];
    },

    currentState() {
      return this.all("ok")
        ? "ok"
        : this.any("loading")
        ? "loading"
        : this.any("error")
        ? "error"
        : "unknown";
    }
  },

  methods: {
    all(key) {
      return (
        this.stateArray.filter(x => x).length > 0 &&
        this.stateArray.filter(x => x !== key).length === 0
      );
    },

    any(key) {
      return this.stateArray.filter(x => x === key).length > 0;
    }
  }
};
</script>

<style></style>
